import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { useMemo, useState } from 'react';
import { ConsoleApiContext, ConsoleLogContext } from './contexts';

var ConsoleProvider = function ConsoleProvider(_ref) {
  var children = _ref.children;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      log = _useState2[0],
      setLog = _useState2[1];

  var api = useMemo(function () {
    return {
      log: function log(lines) {
        return setLog(function (previousLog) {
          return _objectSpread(_objectSpread({}, previousLog), lines);
        });
      },
      replace: function replace(lines) {
        return setLog(lines);
      },
      clear: function clear() {
        return setLog({});
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(ConsoleApiContext.Provider, {
    value: api
  }, /*#__PURE__*/React.createElement(ConsoleLogContext.Provider, {
    value: log
  }, children));
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default ConsoleProvider;